import { NgModule } from '@angular/core';
import { NgGalleryComponent } from './ng-gallery.component';
 
import { RendererComponent } from './renderer/renderer.component';
 
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { GalleryComponent } from './gallery/gallery.component';
import {MatSliderModule} from '@angular/material/slider';
import {MatRippleModule} from '@angular/material/core';
@NgModule({
  declarations: [NgGalleryComponent, RendererComponent, ProgressBarComponent, GalleryComponent],
  imports: [
    MatSliderModule,
    CommonModule,
    MatRippleModule
  ],
  providers:[
 
  ],
  exports: [NgGalleryComponent]
})
export class NgGalleryModule { }
